import React from 'react';
import { Box } from '@99designs/emu';
import { maxWidths } from '@99designs/emu/settings';
import { trackEvent } from '@99designs/tracking';
import { Props as BlogPostProps } from '../../../../shared/components/BlogPost/BlogPost';
import Heading from '../../../../shared/components/Heading';
import TabbedContent from '../../../../shared/components/TabbedContent';
import scrollToElement from '../../../../shared/lib/scrollToElement';
import RelatedBlogPosts from './RelatedBlogPosts';
import RelatedCategories from './RelatedCategories';
import RelatedResources from './RelatedResources';

interface Props {
    categoryKey: string;
    blogPosts: BlogPostProps[];
    cta?: React.ReactNode;
}

function ResourcesSection({ categoryKey, blogPosts, cta }: Props) {
    return (
        <Box
            marginLeft="auto"
            marginRight="auto"
            paddingX={['1bu', '2bu', '2bu', '2bu']}
            paddingY={['3bu', '3bu', '4bu', '6bu']}
            maxWidth={`${maxWidths.content.widescreen}px`}
        >
            <Heading type="h2" variations={['h2']}>
                {__('Logo design resources')}
            </Heading>
            <TabbedContent
                data={
                    blogPosts
                        ? [
                              {
                                  id: 'great-reading',
                                  title: __('Great reading'),
                                  content: <RelatedBlogPosts blogPosts={blogPosts} />,
                              },
                              {
                                  id: 'why-logo-design',
                                  title: __('Why logo design'),
                                  content: <RelatedCategories />,
                              },
                              {
                                  id: 'build-your-brand',
                                  title: __('Build your brand'),
                                  content: <RelatedResources />,
                              },
                          ]
                        : [
                              {
                                  id: 'why-logo-design',
                                  title: __('Why logo design'),
                                  content: <RelatedCategories />,
                              },
                              {
                                  id: 'build-your-brand',
                                  title: __('Build your brand'),
                                  content: <RelatedResources />,
                              },
                          ]
                }
                collapseOn={['small']}
                onChange={(id) =>
                    trackEvent('Clicked Tabbed Content Anchor', {
                        category: categoryKey,
                        content_id: id,
                    })
                }
                onTabClick={(element) => scrollToElement(element, 260)}
            />
            {cta && (
                <Box display="flex" justifyContent="center" marginTop="1.5bu">
                    {cta}
                </Box>
            )}
        </Box>
    );
}

export default ResourcesSection;
